<div class="px-4 py-6">
    <sh-stepper [attr.value]="stepperValue()" vertical>
        <sh-stepper-item
            label="Request submitted"
            [attr.active]="stepperValue() === 1 ? true : null"
            [attr.type]="stepperValue() >= 1 ? 'success' : null"
        ></sh-stepper-item>
        <sh-stepper-item
            label="Under review"
            [attr.active]="stepperValue() === 2 ? true : null"
            [attr.type]="stepperValue() >= 2 ? 'success' : null"
        ></sh-stepper-item>
        <sh-stepper-item
            label="Referred Out"
            [attr.active]="stepperValue() === 3 ? true : null"
            [attr.type]="stepperValue() >= 3 ? 'success' : null"
        ></sh-stepper-item>
        <sh-stepper-item
            label="Request resolved"
            [attr.active]="stepperValue() === 4 ? true : null"
            [attr.type]="stepperValue() >= 4 ? 'success' : null"
        ></sh-stepper-item>
    </sh-stepper>
</div>
